import React, { useState } from "react";
import styles from "../styles/simpleConfig.module.css";
import { BACKEND_URL } from "../config";

const SimpleConfig = ({ updateRevisions, setShowPremiumModal, setQuotaErrorMessage }) => {
    const [curveName, setCurveName] = useState("");
    const [difficulty, setDifficulty] = useState("easy");
    const [loading, setLoading] = useState(false);

    const addMemoryCurve = async () => {
        console.log("Ajout d'une courbe");
        const userId = sessionStorage.getItem("user_id");
        if (!userId) {
            alert("Please log in first.");
            return;
        }

        let K = difficulty === "easy" ? 0.9 : 0.7;
        let C1 = difficulty === "easy" ? 4000 : 6000;
        let C2 = difficulty === "easy" ? 3 : 5;
        const step = 100;
        const synchroGoogleCalendar = false;

        const payload = {
            user_id: userId,
            revision_name: curveName,
            K,
            C1,
            C2,
            step,
            synchroGoogleCalendar
        };

        setLoading(true);

        try {
            console.log("Appel à l'API pour ajouter la courbe");
            const response = await fetch(`${BACKEND_URL}/add-memory-curve`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(payload),
            });

            const data = await response.json();
            if (response.ok) {
                alert("Memory curve added successfully!");
                setCurveName(""); // Réinitialiser le champ
                if (updateRevisions) {
                    updateRevisions();
                }
            } else {
                console.error("Backend error:", data); // Afficher l'erreur détaillée dans la console
                
                // Vérifier si c'est une erreur de quota (403)
                if (response.status === 403 && data.detail && data.detail.includes("Maximum number of memory curves reached")) {
                    // Capturer et afficher le message d'erreur via les props
                    setQuotaErrorMessage(data.detail);
                    setShowPremiumModal(true);
                } else {
                    // Pour les autres erreurs, afficher une alerte normale
                    alert(data.detail || "Failed to add memory curve");
                }
            }
        } catch (error) {
            console.error("Error adding memory curve:", error);
            alert("An error occurred. Please try again.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className={styles.tabContent}>
            <h3>Simple Configuration</h3>
            <label className={styles.label}>Revision Name:</label>
            <input 
                className={styles.input} 
                type="text" 
                value={curveName} 
                onChange={(e) => setCurveName(e.target.value)} 
                placeholder="Enter revision name" 
                required 
            />

            <label className={styles.label}>Difficulty:</label>
            <select 
                className={styles.select} 
                value={difficulty} 
                onChange={(e) => setDifficulty(e.target.value)} 
                required
            >
                <option value="easy">Easy</option>
                <option value="hard">Hard</option>
            </select>

            <button className={styles.addButton} onClick={addMemoryCurve} disabled={loading}>
                {loading ? "Adding..." : "Add"}
            </button>
        </div>
    );
};

export default SimpleConfig;
